import {remCalc} from '_themeUtils'
import {keyframes} from '@emotion/react'

const buttonAnimation = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(8px);
    }
`

const scrollDownButton = {
    ScrollDownButton: {
        baseStyle: ({arrowColor}) => ({
            wrapper: {
                p: remCalc(7),
                // marginBottom: {base: 'spacing.6', md: 'spacing.8', xl: 'spacing.16'},
                color: arrowColor,
                background: 'color.background.transparent',
                _hover: {
                    color: arrowColor,
                },

                '& > button': {
                    background: 'color.background.transparent',
                },
            },
            svg: {
                animation: `${buttonAnimation} infinite 0.75s alternate`,
                minW: remCalc(50),
                maxW: remCalc(50),
                minH: remCalc(50),
                maxH: remCalc(50),
            },
        }),
    },
}
export default scrollDownButton
